<script>
import BaseMediaObject from './../../../global/BaseMediaObject';

// import { EventBus } from './../../../event-bus.js';

export default {
   extends: BaseMediaObject,
   data() {
      return {
         recid: 0,
         objectData: {},
         slots: [],
         slotsToDelete: [], //slots to be deleted on Save
         contentDisplayed: true,

         categories: [],
         channels: [],

         loadComponents: false,
         isNew: false,
         editInstModal: false,
         showMP: false,

         /*Edit Instance Modal */
         editInstRecid: '',
         editInstSlotOrder: 0, //keep track of order so that we can refresh the slot after edit

         stageModal: false,
         reviewersParam: [],
         noteParam: [],
         titleErrorParam: '',

         saved: false,
         resetTrigger: false
      }
   },

   props: {
      assetRecid: String | Number,
      channel: String | Number
   },

   mounted() {
      let self = this;
      if (this.recid > 0) { //get the block object
         this.getObjectData().then(() => {
            this.getChannels();
            this.getCategories();
            this.getSlots();
         });
      } else {
         this.isNew = true;
      }

      // EventBus.$on('open-media-picker',  function(slotRecid, activeAssetRecid, isInstanceSlot) {
      //    self.activeId = slotRecid;
      //    self.activeCurrentAssetId = activeAssetRecid;
      //    if (isInstanceSlot){
      //       self.activeType = [10];
      //    } else {
      //       self.activeType = [1, 2, 3, 4, 6, 10];
      //    }
      //    self.showMP = true;  
      //    self.handleOpenMP(slotRecid, activeAssetRecid, isInstanceSlot);
      // });

      //sent by SlotRow
      // EventBus.$on('edit-instance', function(instanceRecid, order) {
      //    self.editInstSlotOrder = order;
      //    self.editInstRecid = instanceRecid;
      //    self.editInstModal = true;
      // });

      // //media picker is closed
      // EventBus.$on('close-mp-save',  function() {
      //    self.showMP = false;
      //    self.activeId = 0;
      // });
   },

   methods: {
      getObjectData() {
         //implemented by children
      },

      getChannels() {
         //implemented by children
      },

      getCategories() {
         //implemented by children
      },

      getSlots() {
         //implemented by children
      },

      tryUpdate() {
         //implemented by children
      },

      tryCreate() {
         //implemented by children
      },

      handleOpenMP(slotRecid, activeAssetRecid, isInstanceSlot) {
         //for children to implement extra actions when media picker is opened
      },

      additionalSaveActions() {
         //for children to implement extra actions when saved
      },

      load() {
         //for children to implement 
      },

      reset() {
         let self = this;
         this.slotsToDelete = [];
         this.getObjectData().then(() => {
            self.getChannels();
            self.getCategories();
            self.resetTrigger = !self.resetTrigger;
         });
      },

      saveChannels() {
         //implemented by children
      },

      saveCategories() {
         //implemented by children
      },

      // save() {
      //    let self = this;

      //    //assign listener for when the slots finish saving.
      //    //after the block is saved our 'saved' trigger will
      //    //trigger BaseDisplayAssets to save its slots and 
      //    //send this event when finished
      //    EventBus.$on('slots-saved', () => {
      //       self.closeBlock(true);
      //       EventBus.$off('slots-saved');
      //    });

      //    this.trySave().then((recid) => {
      //       self.recid = recid;
      //       self.additionalSaveActions();
      //       self.saved = true;
      //    }).catch((err) => {
      //       if (err) {
      //          //send event to Schedule
      //          if (err.message == 'Missing title') {
      //             EventBus.$emit('MissingTitle');
      //          } else if (err.message == "Conflicting blocks") {
      //             EventBus.$emit('ConflictingBlocks', err.conflictingChanRecs);
      //          } else if (err.message == "Invalid times") {
      //             EventBus.$emit('InvalidTimes');
      //          }
      //       }
      //    });
      // },

      stageForApproval(reviewers, note) {
         let self = this;
         this.tryStage(reviewers, note).then(() => {
            self.closeBlock(true);
         });
      },

      validateAllSlotsFilled() {
         for (let slot of this.slots) {
            if (slot.c_asset_fk < 0) {
               return false;
            }
         }
         return true;
      },

      closeModal() {
         // this.getSlots();
         this.editInstModal = false;
      },

      convertDate(date) {
         let dateObj = new Date(date);
         date = dateObj.toISOString().split('T')[0];
         let dateTime = dateObj.toISOString().split('T')[1].split('.')[0];
         date = date + ' ' + dateTime;
         return date;
      },

      closeMediaPicker() {
         this.showMP = false;
         this.activeId = 0;
         this.activeCurrentAssetId = 0;
         this.activeType = 0;
      },

      saveMP() {
         this.showMP = false;
         this.activeId = 0;

         for (let slot of this.slots) {
            slot.new = false;
         }
      },

      cancelMP() {
         //remove the newly added slots
         let newSlots = this.slots.filter((slot) => !slot.new);

         this.slots = newSlots;
         this.showMP = false;
      },
   },

   watch: {
      assetRecid() {
         this.getBlockData();
      }
   }
}
</script>